<!-- Header -->
<h1 class="py-3">
    <i class="fa fa-star d-block pb-3"></i>
    {{'gen_rate' | translate}}
</h1>
<button type="button" class="close-button" (click)="dialogRef.close()">&times;</button>

<!-- Message -->
<div>
    <!-- Rating -->
    <bar-rating [(rate)]="rate" [max]="5"></bar-rating>
</div>

<!-- Buttons -->
<div class="mt-5">
    <button class="button bblg sm-100 my-3" (click)="submitRate()">{{ "gen_ok" | translate}}</button>
    <button class="button bblg sm-100" (click)="dialogRef.close()">{{ "gen_cancel" | translate}}</button>
</div>